<template>
  <div>
    <v-btn @click="loadLink">Link Account</v-btn>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-btn
        flat
        @click="snack = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'

  export default {
    components: {

    },
    props: {
        client_id: {
            type: [Number, String],
            required: true
        }
    },
      data: () => ({
      token_link: '',
          handler: null,
          snack: false,
          snackColor: '',
          snackText: ''
    }),
    created () {
      this.getTokenLink()
    },
    methods: {
      getTokenLink () {
          if (this.client_id != '') {
              axios.get('/api/admin/clients/' + this.client_id + '/token')
                  .then(response => {
                      this.token_link = response.data.link_token
                      this.createHandler()
                  })
                  .catch(err => {
                      if (err.response.status == '403') {
                          this.showError('Unauthorized')
                      } else {
                          this.showError(err.response.data.errors)
                      }
                      console.log(err.response.data.errors)
                  })
          }
      },
        onSuccess (public_token, metadata) {
          console.log('public token: ' + public_token)
            if (this.client_id != '') {
                axios.post('/api/admin/clients/' + this.client_id + '/token', { public_token: public_token })
                    .then(() => {
                        this.snack = true
                        this.snackColor = 'success'
                        this.snackText = 'Payment information created!'
                    })
                    .catch(err => {
                        if (err.response.status == '403') {
                            this.showError('Unauthorized')
                        } else {
                            this.showError(err.response.data.errors)
                        }
                        console.log(err.response.data.errors)
                    })
            }
        },
    createHandler () {
        this.handler = Plaid.create({
            // Create a new link_token to initialize Link
            token: this.token_link,
        onLoad: function () {
            // Optional, called when Link loads
        },
        onSuccess: this.onSuccess
        // onExit: function(err, metadata) {
        //     // The user exited the Link flow.
        //     if (err != null) {
        //         // The user encountered a Plaid API error prior to exiting.
        //     }
        //     // metadata contains information about the institution
        //     // that the user selected and the most recent API request IDs.
        //     // Storing this information can be helpful for support.
        // },
        // onEvent: function(eventName, metadata) {
        //     // Optionally capture Link flow events, streamed through
        //     // this callback as your users connect an Item to Plaid.
        //     // For example:
        //     // eventName = "TRANSITION_VIEW"
        //     // metadata  = {
        //     //   link_session_id: "123-abc",
        //     //   mfa_type:        "questions",
        //     //   timestamp:       "2017-09-14T14:42:19.350Z",
        //     //   view_name:       "MFA",
        //     // }
        // }
    })
    },
        loadLink () {
          this.handler.open()
        }
    }
  }
</script>
